import { Stack } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { CSSProperties, ReactNode } from "react";

import useViewport from "hooks/useViewport";
import IconSearch from "../Icons/Search";

export type GridItemType = {
  content: ReactNode;
  gridItemSetting: GridItemSetting;
  onClick?: () => void;
  isZoomIn?: boolean;
  isGalerryIcon?: boolean;
  isCenterIcon?: boolean;
  filterBrightnessPercent?: number;
};

export type GridItemSetting = {
  name?: string;
  h?: { base?: string; md?: string };
  flex?: number;
};

const CardMotion = ({
  content,
  gridItemSetting,
  onClick,
  isZoomIn = false,
  isGalerryIcon = true,
  isCenterIcon = false,
  filterBrightnessPercent = 90,
}: GridItemType) => {
  const { isMobile, isTablet } = useViewport();

  const getHeight = (): string => {
    if (isMobile || isTablet) {
      return gridItemSetting.h?.base ?? "200px";
    }

    return gridItemSetting.h?.md ?? "100%";
  };

  const getFlex = (): number | "unset" => {
    if (isMobile || isTablet) {
      return "unset";
    }

    return gridItemSetting.flex ? 1 : "unset";
  };

  const wrapperStyle: CSSProperties = {
    display: "flex",
    cursor: "pointer",
    position: "relative",
    gridArea: gridItemSetting.name,
    borderRadius: "16px",
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "flex-start",
    overflow: "hidden",
    height: getHeight(),
    flex: getFlex(),
  };

  if (isZoomIn) {
    return (
      <Stack
        position="relative"
        style={wrapperStyle}
        overflow="hidden"
        role="group"
      >
        <motion.div
          whileHover={{
            scale: 1.01,
            filter: `brightness(${filterBrightnessPercent}%)`,
          }}
          transition={{ duration: 0.2 }}
          onClick={onClick && onClick}
          style={{
            display: "flex",
            flex: getFlex(),
            height: getHeight(),
          }}
        >
          {content}
        </motion.div>
        {isGalerryIcon && (
          <IconSearch
            pointerEvents="none"
            fill="ud-white"
            zIndex={2}
            position="absolute"
            top={isCenterIcon ? "50%" : "unset"}
            left={isCenterIcon ? "50%" : "unset"}
            bottom={isCenterIcon ? "unset" : "24px"}
            right={isCenterIcon ? "unset" : "24px"}
            transform={isCenterIcon ? "translate(-50%, -50%)" : "unset"}
            display="none"
            boxSize={isCenterIcon ? "36px" : "24px"}
            _groupHover={{
              display: "block",
            }}
          />
        )}
      </Stack>
    );
  }

  return (
    <motion.div
      whileHover={{
        scale: 1.01,
        filter: `brightness(${filterBrightnessPercent}%)`,
      }}
      transition={{ duration: 0.2 }}
      onClick={onClick && onClick}
      style={wrapperStyle}
    >
      {content}
    </motion.div>
  );
};

export default CardMotion;
